import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DocumentDto, DocumentsDto, DocumentStatusDto } from '../models/DocumentDto';
import { GenericFilter } from '../models/GenericFilter';
import { BaseService } from './base.service';
import { OAuthServiceService } from './o-auth-service.service';

@Injectable({ providedIn: 'root' })
export class DocumentService extends BaseService {
  

  constructor(private httpClient: HttpClient,
    private oauthService: OAuthServiceService) {
    super();
  }

  loadDocuments(searchText: string, docStereoTypeId: string, page: number, pageSize: number, dbname: string): Observable<DocumentsDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.get<DocumentsDto>(`${this.documents}?searchText=${searchText}&docStereoTypeId=${docStereoTypeId}&page=${page}&pageSize=${pageSize}`, { headers: headers });
  }

  loadAllDocuments(docStereoTypeId: string, genericFilter: GenericFilter, dbname: string): Observable<DocumentDto[]> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.post<DocumentDto[]>(`${this.documents}/${docStereoTypeId}/GetFilteredDocuments`, genericFilter, { headers: headers });
  }

  getDocument(id: string, dbname: string): Observable<DocumentDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.get<DocumentDto>(`${this.documents}/${id}/GetDocument`, { headers: headers });
  }

  getDocumentStatus(id: string, dbname: string): Observable<DocumentStatusDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.get<DocumentStatusDto>(`${this.documents}/${id}/DocumentStatus`, { headers: headers });
  }

  createDocument(documentDto: DocumentDto, dbname: string): Observable<DocumentDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.post<DocumentDto>(`${this.documents}`, documentDto, { headers: headers });
  }

  updateDocument(documentDto: DocumentDto, dbname: string): Observable<DocumentDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.put<DocumentDto>(`${this.documents}`, documentDto, { headers: headers });
  }

  deleteDocument(documentDto: DocumentDto, dbname: string): Observable<DocumentDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.delete<DocumentDto>(`${this.documents}/${documentDto.id}`, { headers: headers });
  }

  uploadFile(formData: FormData, dbname: string): Observable<any> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.post<any>(`${this.documents}/UploadFile`, formData, { headers: headers, reportProgress: true, observe: 'events' });
  }
}
